import React from 'react';
import { Flex } from '@chakra-ui/react';
import Logo from '../Logo';

const Head = () => (
  <Flex bgColor="gray.800" justify="center" p="10">
    <Logo />
  </Flex>
);

export default Head;
